import { Component, OnInit } from '@angular/core';
import { AppService, AppSettings } from '../../core';

@Component({
    selector: 'app',
    template: require('./app.component.html'),
})
export class AppComponent implements OnInit {
    notifications: any = {
        timeOut: 5000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: false,
        maxStack: 10
    };
    termsAndConditionsArticleId: number;

    public readonly APP_VERSION = AppSettings.APP_VERSION;
    public readonly APP_RELEASE = AppSettings.APP_RELEASE;

    constructor(
        private _appService: AppService
    ) { }

    ngOnInit() {
        this._appService
            .getSettings()
            .subscribe(data => this.termsAndConditionsArticleId = data.termsAndConditionsArticleId);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/app.component.ts